var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", { class: _vm.$style.heading }, [
      _vm._v("\n    Set Up Verification Code (TOTP) MFA\n  "),
    ]),
    _vm._v(" "),
    _c("div", { class: _vm.$style.body }, [
      _c(
        "div",
        { class: _vm.$style.mainContent },
        [
          _c(
            "AdminTotpSetupStep",
            { attrs: { number: 1, title: "Download an Authenticator App" } },
            [
              _c("template", { slot: "adminTotpSetupStepMessage" }, [
                _c("p", [
                  _vm._v("\n            To get set up, download "),
                  _c("strong", [_vm._v("JumpCloud Protect")]),
                  _vm._v(" or one of our\n            "),
                  _c(
                    "a",
                    {
                      class: [_vm.$style.textLink],
                      attrs: {
                        href: _vm.qualifiedAppsUrl,
                        rel: "noopener noreferrer",
                        target: "_blank",
                      },
                    },
                    [
                      _vm._v(
                        "\n              qualified authentication applications"
                      ),
                    ]
                  ),
                  _vm._v("\n            on your mobile device.\n          "),
                ]),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("aside", { class: _vm.$style.linksCardContainer }, [
        _c("div", { class: _vm.$style.linksCard }, [
          _c(
            "a",
            {
              class: _vm.$style.link,
              attrs: {
                href: _vm.androidPlayStoreUrl,
                rel: "noopener noreferrer",
                target: "_blank",
              },
            },
            [
              _c("img", {
                class: _vm.$style.image,
                attrs: { src: _vm.androidPlayStoreImageSrc },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              class: _vm.$style.link,
              attrs: {
                href: _vm.appleAppStoreUrl,
                rel: "noopener noreferrer",
                target: "_blank",
              },
            },
            [
              _c("img", {
                class: _vm.$style.image,
                attrs: { src: _vm.appleAppStoreImageSrc },
              }),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { class: _vm.$style.footer },
      [
        _c(
          "LoginActionButton",
          { class: _vm.$style.actionButton, attrs: { action: _vm.goForward } },
          [_vm._v("\n      I Have An App\n    ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }